import React from "react";
import { FAQ_ITEMS } from "../seo/faqContent.js";
export const GUIDE_PATH = "/tjana-pengar-till-klassresan";
export const GUIDE_TITLE =
  "Tjäna pengar till klassresan – så gör ni | SalesPartner";
export const GUIDE_H1 =
  "Tjäna pengar till klassresan – så planerar ni och når målet";
export const GUIDE_DESCRIPTION =
  "Så tjänar klassen pengar till klassresan: räkna ut målet, gör en tidsplan, välj insamlingssätt och sköt klasskassan. Med kalkylator och vanliga frågor.";
export const GUIDE_ANSWER =
  "Klassen tjänar pengar till klassresan genom att sätta ett mål i kronor, dela upp det per elev, välja ett eller flera sätt att samla in pengar och följa en tidsplan. Klassförsäljning kan kombineras med loppis, kafé, pant eller sponsorer, beroende på vad som passar klassen.";
export const GUIDE_SECTIONS = [
  ["mal", "1. Sätt målet i kronor"],
  ["tidsplan", "2. Gör en tidsplan"],
  ["insamlingssatt", "3. Välj sätt att samla in pengar"],
  ["klasskassan", "4. Sköt klasskassan tryggt"],
  ["salj-smart", "5. Sälj smart"],
  ["salespartner", "Så hjälper SalesPartner klassen"],
  ["fragor", "Vanliga frågor om pengar till klassresan"],
  ["borja", "Börja samla till klassresan"],
];
export const GOAL_PARAGRAPHS = [
  "Börja med resan ni vill göra tillsammans, inte med hur mycket varje elev ska sälja. Skriv upp vad som behöver betalas: själva resan, eventuellt boende, mat och planerade aktiviteter. Fundera också på om ni vill ha en buffert för utgifter som ännu inte är bestämda. Det finns inget belopp som passar alla klasser. En dagsutflykt och en resa med övernattning behöver olika planering.",
  "Ta fram underlag för de kostnader som är relevanta för just er och kontrollera med skolan vilket upplägg som är möjligt. Prata sedan om vad klasskassan ska bidra till. Ska den täcka hela resan eller en bestämd del? Att skilja på resans budget och klassens insamlingsmål gör det lättare att förstå vad ni arbetar mot.",
  "Använd målkalkylatorn som ett första samtalsunderlag. Alla belopp i kalkylatorn är ett räkneexempel som ni kan ändra. Antal produkter bygger på ett planeringsvärde och är inte ett löfte om vad klassen kommer att tjäna. Jämför alltid med den faktiska provisionen innan ni bestämmer ert upplägg.",
];
export const TIMELINE_PARAGRAPHS = [
  "Utgå från när ni behöver kunna betala för resan och arbeta bakåt. Lägg in tid för att prata ihop er, förbereda insamlingen, genomföra den och avsluta på ett ordnat sätt. Ett möjligt upplägg är att börja planera på hösten inför en resa på våren. Det är ett planeringsråd, inte ett krav eller ett påstående om vilka månader som fungerar bäst.",
  "Låt tidsplanen vara enkel nog att alla kan följa den. Skriv vem som ansvarar för varje del och när klassen ska stämma av hur det går. Om ni använder flera insamlingssätt kan det vara klokt att sprida ut dem, så att samma familjer inte behöver ordna allt samtidigt.",
];
export const TIMELINE_ROWS = [
  [
    "Planera",
    "Sätt mål, välj sätt att samla in pengar och utse ansvariga vuxna.",
    "Stäm av planen med skolan och prata om hur alla kan delta.",
  ],
  [
    "Förbered",
    "Registrera klassen om ni väljer klassförsäljning och informera föräldrarna.",
    "Förklara mål, roller, tidsplan och hur ni följer klasskassan.",
  ],
  [
    "Sälj",
    "Genomför en aktiv säljperiod och planera in påminnelser.",
    "Följ upp det ni har gjort och anpassa nästa steg tillsammans.",
  ],
  [
    "Avsluta",
    "Ordna leverans och utdelning där det behövs, samla kvitton och redovisa.",
    "Stäm av vad som återstår innan ni bestämmer hur pengarna används.",
  ],
];
export const METHOD_PARAGRAPHS = [
  "Det finns flera sätt att samla in pengar till klassresa och gemensamma aktiviteter. Välj utifrån vilka vuxna som kan hjälpa till, vad eleverna vill göra och vilken tid ni har. Ett upplägg som är enkelt att förklara och fördela kan vara lättare att hålla ihop än många olika aktiviteter på en gång.",
  "Tabellen jämför praktiska förutsättningar, inte hur mycket ni säkert kan tjäna. Arbetsinsatsen beror på hur ni lägger upp aktiviteten. Kontrollera med skolan innan ni planerar sådant som använder skolans lokaler eller berör skolans verksamhet. Stäm också av ansvar och praktiska villkor med den som upplåter en plats eller beställer en insats.",
  React.createElement("span",{key:"guide-links"},React.createElement("a",{href:"/salja-med-klassen"},"Se vad klassen kan sälja")," · ",React.createElement("a",{href:"/tjana-pengar-till-studenten"},"Planerar ni studenten? Läs guiden")),
];
export const METHOD_ROWS = [
  [
    "Klassförsäljning",
    "Förberedelser, delning av länkar och uppföljning.",
    "Ni vill sälja produkter med ett gemensamt upplägg.",
    "Förklara provision, leverans och ansvar innan ni börjar.",
  ],
  [
    "Loppis",
    "Samla in, sortera, ordna plats och bemanna.",
    "Familjer vill bidra med saker de inte längre använder.",
    "Bestäm vad som tas emot och hur osålda saker hanteras.",
  ],
  [
    "Kafé/disco på skolan",
    "Planera inköp, lokal, bemanning och städning.",
    "Ni kan ordna en gemensam aktivitet med vuxnas hjälp.",
    "Kontrollera med skolan och klargör ansvar för genomförandet.",
  ],
  [
    "Pantinsamling",
    "Samordna insamling, sortering och transport.",
    "Ni vill samla pant som familjer kan bidra med.",
    "Berätta vad ni samlar och vem som tar hand om det.",
  ],
  [
    "Sponsring från lokala företag",
    "Ta kontakt, förklara målet och följ upp.",
    "Ni vill undersöka om företag vill bidra.",
    "Kom överens om vad bidraget innebär. Kontrollera med skolan.",
  ],
  [
    "Arbetsdag",
    "Ordna en lämplig uppgift, vuxenstöd och praktisk planering.",
    "Det finns en tydlig insats som klassen kan genomföra.",
    "Stäm av uppgift, ansvar och villkor med skolan och uppdragsgivaren.",
  ],
];
export const FUND_PARAGRAPHS = [
  "Prata om klasskassan innan de första pengarna kommer in. Undersök möjligheten att ha ett konto för klassen i stället för att blanda klassens pengar med en vuxens privata ekonomi. Det är ett generellt råd om överblick, inte ett besked om vilken kontoform ni kan öppna. Regler och kontoformer kan variera – kontrollera med skolan och banken.",
  "Välj gärna två ansvariga vuxna som tillsammans kan följa insamlingen och hålla ordning på underlagen. Bestäm hur ni fattar beslut, vem som sköter praktiska ärenden och hur ni lämnar över ansvaret om någon slutar. Fråga banken vilka möjligheter som finns att få den insyn och ansvarsfördelning ni vill ha.",
  "Spara kvitton och andra underlag och gör en enkel sammanställning av det som kommer in och det som används. Berätta regelbundet för föräldrarna hur det går. En redovisning behöver vara begriplig: vad har klassen samlat in, vilka utgifter har ni haft och vad återstår till det gemensamma målet?",
  "Kom också överens om vad pengarna får användas till. Skriv ner beslut om klassresan och andra gemensamma aktiviteter så att alla har samma bild. Om ni undrar över regler för klasskassan eller ett klasskonto, kontrollera med skolan respektive banken i stället för att utgå från att en annan klass har samma förutsättningar.",
];
export const SELL_TIPS = [
  [
    "Dela med familj och släkt",
    "Berätta om klassens mål och dela den personliga säljlänken eller QR-koden med dem som vill stötta. Med SalesPartner kopplas beställningarna via länken till rätt säljare och grupp.",
  ],
  [
    "Sätt ett delmål per vecka",
    "Dela upp arbetet i mindre steg som ni kan prata om tillsammans. Det kan handla om vad ni ska göra och följa upp, snarare än ett löfte om ett visst försäljningsbelopp.",
  ],
  [
    "Påminn mitt i perioden",
    "Planera en vänlig påminnelse så att den som varit intresserad får möjlighet att återkomma. Håll informationen tydlig och låt mottagaren själv välja om den vill handla.",
  ],
  [
    "Berätta vad pengarna ska användas till",
    "Förklara vilken klassresa eller aktivitet ni samlar till. Ett tydligt gemensamt mål gör det lättare att förstå varför klassen delar länkar och vad ett köp bidrar till.",
  ],
  [
    "Tacka kunderna",
    "Tacka dem som handlar och hjälper er att sprida informationen. När ni avslutar försäljningen kan ni också berätta hur det gemensamma arbetet har gått, utan att lova ett visst resultat i förväg.",
  ],
];
const answer = (q) => FAQ_ITEMS.find((item) => item.q === q).a;
export const GUIDE_FAQ = [
  {
    q: "Hur mycket pengar behöver klassen?",
    a: "Börja med kostnaderna för just er resa och bestäm vad klasskassan ska täcka. Använd målkalkylatorn som stöd. Räkneexempel: 25 elever och 800 kr per elev ger ett mål på 20 000 kr. Med planeringsvärdet 74 kr per produkt motsvarar det cirka 271 produkter, eller 11 produkter per elev. Det är inte en garanti.",
  },
  {
    q: "När ska vi börja samla in pengar?",
    a: "Utgå från när pengarna behövs och räkna bakåt. Lägg in tid för förberedelser, insamling och avslut. Ni kan exempelvis planera på hösten inför en resa på våren, men anpassa tidsplanen till klassen och kontrollera med skolan vad som passar.",
  },
  {
    q: "Vad är lättast att sälja?",
    a: "Det beror på vilka ni når och vilka produkter ni kan berätta om. Titta tillsammans på sortimentet, jämför produkternas villkor och välj ett upplägg ni förstår. Det finns ingen försäljningsgaranti. I SalesPartners sortiment framgår de aktuella produkterna och priserna.",
    to: "/products",
    label: "Se aktuellt produktsortiment",
  },
  {
    q: "Hur sköter man klasskassan?",
    a: "Kom överens om ansvar, spara kvitton och redovisa enkelt till föräldrarna. Undersök ett konto för klassen och välj gärna två ansvariga vuxna. Regler och kontoformer kan variera – kontrollera med skolan och banken.",
  },
  {
    q: "Behöver eleverna hantera kontanter?",
    a:
      answer("Behöver säljarna hantera kontanter?") +
      " Eleverna kan dela sin personliga säljlänk och QR-kod i stället för att ta emot betalningar själva.",
  },
  {
    q: "Kan pengarna användas till annat än klassresan?",
    a: "Samma upplägg kan användas till klassens gemensamma mål, som en avslutning, klassaktivitet eller gemensamma inköp. Klassen väljer sitt mål. Kom överens om användningen tillsammans med ansvariga vuxna och kontrollera med skolan vad som gäller för ert upplägg.",
  },
];
